class AuthSdkLoader {
  static #instance;

  constructor() {
    this.facebookInitialized = false;
    this.appleInitialized = false;
  }

  static getInstance() {
    if (!AuthSdkLoader.#instance) {
      AuthSdkLoader.#instance = new AuthSdkLoader();
    }
    return AuthSdkLoader.#instance;
  }

  // Load Facebook SDK
  loadFacebookSdk() {
    return new Promise((resolve) => {
      if (window.FB) {
        resolve(window.FB);
        return;
      }

      if (!document.getElementById("facebook-jssdk")) {
        const js = document.createElement("script");
        js.id = "facebook-jssdk";
        js.src = "https://connect.facebook.net/en_US/sdk.js";
        js.onload = () => {
          this.facebookInitialized = true;
          resolve(window.FB);
        };
        js.onerror = () => resolve(null);
        document.getElementsByTagName("head")[0].appendChild(js);
      }
    });
  }

  // Load Apple SDK
  loadAppleSdk() {
    return new Promise((resolve, reject) => {
      if (window.AppleID) {
        resolve(window.AppleID);
        return;
      }

      if (!document.getElementById("apple-signin-sdk")) {
        const script = document.createElement("script");
        script.id = "apple-signin-sdk";
        script.type = "text/javascript";
        script.src =
          "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
        script.onload = () => {
          this.appleInitialized = true;
          resolve(window.AppleID);
        };
        script.onerror = () => reject(new Error("Failed to load Apple SDK"));
        document.head.appendChild(script);
      }
    });
  }

  async initializeAll(callback) {
    const promises = [
      this.loadFacebookSdk(callback).catch(() => null),
      this.loadAppleSdk(callback).catch(() => null),
    ];

    await Promise.allSettled(promises);
  }
}

export const authSdk = AuthSdkLoader.getInstance();
